import { scrollToEl, headerOffsetHeight } from './helpers';

function scrollToHashOnLoad() {
    const { hash } = window.location;
    if (hash) {
        // To top right away.
        window.scroll(0, 0);
        // Void some browsers issue.
        setTimeout(
            () => {
                window.scroll(0, 0);
            }, 1,
        );
        scrollToEl(document.querySelector(hash), headerOffsetHeight());
    }
}

export default scrollToHashOnLoad;
